import { Component } from '@angular/core';
import { SpinnerComponent } from '@coreui/angular-pro';

@Component({
  selector: 'app-spinner',
  imports: [SpinnerComponent],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class LoadingSpinnerComponent {

}
